/* 🤖 this file was generated by script */
export const wsolidiconUser01 = {
  name: 'user_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.79 14.5h6.42a10 10 0 0 1 1.66.08 5 5 0 0 1 4.05 4.05c.08.43.08.93.08 1.66q0 .23-.02.47A1.5 1.5 0 0 1 19.4 22a1381 1381 0 0 0-15.17-.02 1.5 1.5 0 0 1-1.22-1.22Q3 20.52 3 20.3c0-.73 0-1.23.08-1.66a5 5 0 0 1 4.05-4.05 10 10 0 0 1 1.66-.08M6.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
